module.exports = __webpack_public_path__ + "media/images/athletes/1744-c623da88be4571fee05312ac2796bf5d.png";